<template>
  <section class="statistics">
    <div class="statistics-content">
      <div
        v-for="(item, index) in learnInfo.obj.data1"
        :key="index"
        class="statistics-content-card"
      >
        <img :src="item.url" alt="">
        <div>{{ item.title }}</div>
        <el-button @click="handleRoute(item.path)">
          {{ item.option }}
        </el-button>
      </div>
    </div>
  </section>
</template>
<script>
import mock from '@/utils/mock'
export default {
  components: {},
  data() {
    return {
      learnInfo: mock.learn.learn.viewInfo,
      learnInit: mock.learn.learn.init
    }
  },
  mounted() {

  },
  methods: {
    handleRoute(v) {
      this.$router.push(v)
    }
  }
}
</script>
<style lang="scss" scoped>
.statistics-content {
  width: 1100px;
  min-width: 1100px;
  margin: 0 auto;
  position: relative;
  height: 85vh;
  display: flex;
  align-items: center;
  justify-content: space-around;
  &-card {
    width: 363px;
    height: 384px;
    border-radius: 10px;
    background-color: white;
    position: relative;
    text-align: center;
    > img{
        position: absolute;
    top: 65px;
    left: 50%;
    transform: translateX(-50%);
    }
    > div{
        color: #444;
        font-size: 16px;
        font-weight: bold;
            top: 204px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    }
    .el-button{
            top: 284px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    }
  }
}

</style>
